import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import QRCode from "react-qr-code";

import type { PartyShellPalette } from "../theme/theme";

type Props = {
  joinUrl: string;
  partyPal: PartyShellPalette;
  qrCaption: string;
  qrHint: string;
  copyLabel: string;
  copyDoneLabel: string;
  copied: boolean;
  onCopy: () => void;
};

/** Matches Answer Bluff QR + copy block for a consistent party UX. */
export function ImposterOnlineQrSharePanel({
  joinUrl,
  partyPal,
  qrCaption,
  qrHint,
  copyLabel,
  copyDoneLabel,
  copied,
  onCopy,
}: Props) {
  if (!joinUrl) return null;
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 2,
        mx: 2.5,
        borderRadius: 3,
        border: `1.5px solid ${partyPal.inkFaint}`,
        bgcolor: "rgba(255,255,255,0.04)",
      }}
    >
      <Stack spacing={1.5} alignItems="center">
        <Typography sx={{ fontSize: 14, fontWeight: 800, color: partyPal.ink }}>{qrCaption}</Typography>
        <Box sx={{ bgcolor: "#fff", p: 1.5, borderRadius: 2, lineHeight: 0 }}>
          <QRCode value={joinUrl} size={196} level="M" />
        </Box>
        <Typography sx={{ fontSize: 12, color: partyPal.inkDim, textAlign: "center", lineHeight: 1.45, px: 1 }}>{qrHint}</Typography>
        <Button
          type="button"
          variant="outlined"
          size="small"
          startIcon={<ContentCopyIcon sx={{ fontSize: 18, color: partyPal.ink }} />}
          onClick={onCopy}
          className="party-btn party-btn-paper"
          sx={{ mt: 0.5, borderColor: partyPal.inkFaint, color: partyPal.ink, textTransform: "none" }}
        >
          {copyLabel}
        </Button>
        {copied ? (
          <Typography sx={{ fontSize: 12, color: partyPal.hot, fontWeight: 700 }}>{copyDoneLabel}</Typography>
        ) : null}
      </Stack>
    </Paper>
  );
}
